import React from "react";

const Feedbacks = () => {
    return (
        <div className="ms-md-5">
            <div className="row g-4">
                <div className="col-md-9 row g-3">
                    <div>
                        <h2 className="text-success">
                            <u>
                                Best tour operator in Bangladesh to organize
                                tours with variety
                            </u>
                        </h2>
                        <p>
                            We specialize in organizing inbound tours in
                            Bangladesh, from day tours to month long holidays,
                            specially off the beaten tours which no one else
                            does here. Showing people and culture of this
                            country is always our highlights in any tour. We
                            organize Nature & Wildlife tours, Hiking & Camping
                            tours, Cycling tours, Bird Watching tours, River &
                            Canals tours specially in monsoon when they are full
                            of water and green on it’s fullest, Photography
                            tours, City tours, and many other tours in
                            Bangladesh. <br /> Come and visit Bangladesh with us
                            to have the best possible experience! It is the most
                            overlooked country in the world, and a hidden gem in
                            south Asia about which very few people actually
                            know. It’s amazingly hospitable people is waiting to
                            welcome you everywhere!
                        </p>
                    </div>
                    <div>
                        <h2 className="text-success">
                            <u>
                                A tour operator in Bangladesh where quality
                                always comes first
                            </u>
                        </h2>
                        <p>
                            In Tour Holiday, we try to understand the needs of
                            our clients, and work hard to full-fill them. We
                            never compromise with the quality of our service.
                            For that reason, withing the first year of founding,
                            Holiday Tours got in the top position in TripAdvisor
                            among all the tour operators in Bangladesh, based on
                            the reviews and ratings from our clients.
                        </p>
                    </div>
                    <div>
                        <h2 className="text-success">
                            <u>A home-grown tour operator in Bangladesh</u>
                        </h2>
                        <p>
                            We specialize in organizing inbound tours in
                            Bangladesh, from day tours to month long holidays,
                            specially off the beaten tours which no one else
                            does here. Showing people and culture of this
                            country is always our highlights in any tour. We
                            organize Nature & Wildlife tours, Hiking & Camping
                            tours, Cycling tours, Bird Watching tours, River &
                            Canals tours specially in monsoon when they are full
                            of water and green on it’s fullest, Photography
                            tours, City tours, and many other tours in
                            Bangladesh.
                        </p>
                    </div>
                </div>
                <div className="col-md-3 row g-2">
                    <img
                        className="img-fluid rounded"
                        src="https://i.ibb.co/L0HK8Tn/tripadvisor2018.png"
                        alt=""
                    />
                    <img
                        className="img-fluid rounded"
                        src="https://i.ibb.co/THjz2yf/reaward.png"
                        alt=""
                    />
                    <img
                        className="img-fluid rounded"
                        src="https://i.ibb.co/x144gmS/trip-a2020.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
    );
};

export default Feedbacks;
